module.exports = __webpack_public_path__ + "img/m-ebook.944ebaa3.png";